import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface PropertyQualityRow {
  property_id: string;
  property_name: string;
  org_name: string;
  data_quality_tier: string | null;
  data_quality_score: number | null;
  quality_reason_codes: string[] | null;
  telemetry_coverage_7d: number | null;
  pv_learning_health: string | null;
  fallback_rate_7d: number | null;
}

export interface DataQualityOverview {
  tierDistribution: Record<string, number>;
  properties: PropertyQualityRow[];
}

async function fetchDataQualityOverview(): Promise<DataQualityOverview> {
  const { data, error } = await supabase.rpc('admin_data_quality_overview');
  if (error) throw error;

  const d = data as {
    tier_distribution: Record<string, number>;
    properties: PropertyQualityRow[];
  };

  return {
    tierDistribution: d.tier_distribution ?? {},
    properties: d.properties ?? [],
  };
}

export function useAdminDataQuality(enabled: boolean, refetchInterval: number | false) {
  return useQuery({
    queryKey: ['admin-data-quality-overview'],
    queryFn: fetchDataQualityOverview,
    enabled,
    refetchInterval,
  });
}
